import { PlanListItem } from '../types';
import {api} from './api';

export interface PlanImportFromIgDto {
	videoId: string;
	title: string;
	description: string;
	channelId: string;
	channelBio: string;
	thumbnailUrl: string;
	authorThumbnailUrl: string;
}

export const planImportApi = api.injectEndpoints({
	endpoints: (builder) => ({
		planImportFromYT: builder.mutation<PlanListItem, {videoId: string}>({
			query: (data) => ({
				url: 'planImport/fromYT',
				method: 'POST',
				body: data,
			}),
			extraOptions: { maxRetries: 1 }
		}),
		planImportFromIG: builder.mutation<PlanListItem, PlanImportFromIgDto>({
			query: (data) => ({
				url: 'planImport/fromIG',
				method: 'POST',
				body: data,
			}),
			extraOptions: { maxRetries: 1 }
		}),
		planImportFromPinterest: builder.mutation<PlanListItem, {pinId: string, pinterestChannelId: string}>({
			query: (data) => ({
				url: 'planImport/fromPinterest',
				method: 'POST',
				body: data,
			}),
			extraOptions: { maxRetries: 1 }
		}),
	}),
});

export const { usePlanImportFromYTMutation, usePlanImportFromIGMutation, usePlanImportFromPinterestMutation } = planImportApi;
